import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { checkExactLength, checkMatch, checkNotEmpty, checkSnils, validateBaseRequisites, } from '../../helpers/validators';
import { MatchLink } from '../MatchLink';
export const validateSnils = ({ value, required, requiredMessage }) => {
    const length = 11;
    const snils = (value || '').replace(/\D/g, '');
    if (required) {
        return (checkNotEmpty({ value, message: requiredMessage }) ||
            checkExactLength({ value: snils, length }) ||
            checkSnils({ value: snils }));
    }
    if (!snils) {
        return null;
    }
    return checkExactLength({ value: snils, length }) || checkSnils({ value: snils });
};
const checkMatchSnils = ({ value, matchValue, matchEmployeeLink, level, }) => {
    const message = (_jsxs(_Fragment, { children: ["\u0421\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A \u0441 \u0442\u0430\u043A\u0438\u043C \u0421\u041D\u0418\u041B\u0421 \u0443\u0436\u0435 \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u0435\u0442", matchEmployeeLink && '. ', matchEmployeeLink && _jsx(MatchLink, { matchEmployeeLink: matchEmployeeLink })] }));
    return checkMatch({ value, matchValue, matchFields: ['snils'], message, level });
};
export const validateSnilsWithMatch = ({ snils, inn, lastName, firstName, required, matchSnilsProps, }) => {
    return (validateSnils({ value: snils, required }) ||
        validateBaseRequisites({ snils, inn, lastName, firstName }) ||
        checkMatchSnils(matchSnilsProps));
};
